import { render, staticRenderFns } from "./ContainerBox.vue?vue&type=template&id=e19d58c6&"
import script from "./ContainerBox.vue?vue&type=script&lang=js&"
export * from "./ContainerBox.vue?vue&type=script&lang=js&"
import style0 from "./ContainerBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports